<template>
    <div class = "wholeWrap">
        <SingleElemDisplay :displayData = "currentPrayer" v-slot="{value}">
            <div class = "prayerWrapper">
                {{value.prayer}}
            </div>
        </SingleElemDisplay>
    </div>
</template>

<script setup>
	import SingleElemDisplay from "@/components/genericDisplay/SingleElemDisplay.vue";
    import {usePrayerList} from "@/composables/prayerList.js";
    import {ref, computed, onMounted, onUnmounted} from "vue";
    import {useRoute} from "vue-router";


    const route = useRoute();

    const {prayerList} = usePrayerList(route.params.clientId);
    const prayerIndex = ref(0);
    const currentPrayer = computed(()=>{
        return prayerList.value[prayerIndex.value];
    });


    function next(){
        if(prayerIndex.value < prayerList.value.length -1){
            prayerIndex.value++;
        } else{
            prayerIndex.value = 0;
        }
    }



    let intervalTrigger
    onMounted(() => {
        intervalTrigger = setInterval(() => {
            next();
        }, 10000);
    });

    onUnmounted(() => {
        clearInterval(intervalTrigger);
    })

</script>

<style scoped>

.wholeWrap{
    position: absolute;
    top: 0px;
    left: 0px;
    overflow-x: hidden;
    overflow-y:visible;
    width: 100vw;
    height: 100vh;
   
    padding-top: 20vh;
}



.prayerWrapper{
    font-size: 3rem;
    width: 100%;

    max-width: 90vw;
    width: 90vw;
    margin-left: auto;
    margin-right: auto; 
}

</style>